import {  Injectable } from '@angular/core';
import {
    HttpClient, HttpHeaders
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { AppConfig } from '../_helpers/appconfig.service';
import { map } from 'rxjs/operators';

@Injectable()
export class TemplateService {

    _kcmssvcURL: string = AppConfig.settings.apiServer.kcmssvcURL.toString();

    httpOptions: any;
    public defaultHeaders = new HttpHeaders();
    constructor(private http: HttpClient) {

    }
    getTemplateType(public_id: string): Observable<any> {
        return this.http.get(`${this._kcmssvcURL}/customers/` + public_id + `/configurations/notification.setup`)
            .pipe(map(res => res)
            );
    }
    
    getTags(){
        return this.http.get(`${this._kcmssvcURL}/notification_templates/tags`);
     }
}